import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { URI_BLOG } from './uri';
import { UserPermission } from '../../users/enums/UserPermission';

const Blog = lazy(() => import('../pages/Blog'));
const BlogArticle = lazy(() => import('../pages/BlogArticle'));

const routes = (userCan: (permission: UserPermission) => boolean): RouteObject[] => {
  if (!userCan(UserPermission.BLOG_READ)) {
    return [];
  }

  return [
    {
      path: URI_BLOG,
      element: <Blog />,
    },
    {
      path: `${URI_BLOG}/:slug`,
      element: <BlogArticle />,
    },
  ];
};

export default routes;
